import { atom } from "jotai";
import { Todo } from "../types";

const todosAtom = atom<Todo[]>([]);

export { todosAtom };
